<!--
     <RiskTable
       :interpreter="risk_interpreter"
     />
-->

<template>
  <div class="rktb-cont">
    <table class="rktb-intertable" cellspacing="0">
      <tr class="rktb rktb-intertable-header">
        <th>Inicio</th>
        <th>Fin</th>
        <th>Color</th>
        <th>Texto</th>
      </tr>
      <tr
        v-for="range, index in interpreter"
        :key="index"
        class="rktb-intertable-row"
      >
        <td class="rktb-num" v-if="index == 0">{{ '' + range.min }}</td>
        <td class="rktb-num" v-if="index > 0">{{ '>' + range.min }}</td>
        <td class="rktb-num">{{ '≤' + range.max }}</td>
        <td class="rktb-color" :style="'background-color:' + range.color"></td>
        <td class="rktb-label">{{ range.label }}</td>
      </tr>
    </table>
  </div>
</template>


<style lang="scss">
 $table-border-color: #666;
 $table-bw: 1px; /*border width*/

 tr.rktb > th {
   text-align: center;
   padding: 8px;
   font-weight: bold;
   border-style: solid;
   border-color: $table-border-color;
   border-width: $table-bw $table-bw 0px 0px;
 }

 table.rktb-intertable {
   border-style: solid;
   border-color: $table-border-color;
   border-width: 0px 0px $table-bw $table-bw;
 }

 tr.rktb-intertable-row > td {
   margin: 0;
   padding: 8px;
   min-width: 72px;
   border-style: solid;
   border-color: $table-border-color;
   border-width: $table-bw $table-bw 0px 0px;
   text-align: center;
 }
 
 td.rktb-num {
   font-family: monospace;
   text-align: right !important;
 }

 td.rktb-color {
   width: 64px;
 }
</style>


<script>
 export default {
   name: 'RiskTable',

   props: {
     interpreter: {required: true},
   },

   components: {
   },

   data: (() => ({
     // :)
   })),

   mounted() {
   },

   computed: {
   },

   methods: {
   },
 }
</script>
